/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useMemo } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { settingsStyles } from '../../settings/screens/settingsScreen.styles';
import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { useBranchPermission } from '../../shell/session/hooks/useBranchPermission';
import { navigateInShell } from '../../shell/navigation/rootNavigation';
import { resolveEmployeeReadyCardVm } from '../application/employeeReadyCardVm';

/** Empleado en Inicio: CTA según permiso + Abrir soporte; sin atajos al menú. */
export function EmployeeReadyCard() {
  const navigation = useNavigation<any>();
  const branchName = useSessionStore((s) => {
    const id = s.currentBranchId;
    return s.branches.find((b) => b.id === id)?.name ?? 'este local';
  });
  const pos = useBranchPermission('POS');
  const cash = useBranchPermission('Cash');
  const orders = useBranchPermission('Orders');

  const vm = useMemo(
    () =>
      resolveEmployeeReadyCardVm({
        branchName,
        posCanView: pos.canView,
        cashCanView: cash.canView,
        ordersCanView: orders.canView,
      }),
    [branchName, pos.canView, cash.canView, orders.canView],
  );

  return (
    <View style={settingsStyles.card} testID="home.employee.ready">
      <Text style={styles.title}>{vm.title}</Text>
      <Text style={settingsStyles.caption}>{vm.body}</Text>
      {vm.primary ? (
        <TouchableOpacity
          style={styles.primaryBtn}
          onPress={() => navigateInShell(navigation, vm.primary!.route)}
          accessibilityRole="button"
          accessibilityLabel={vm.primary.label}
          testID={`home.employee.cta.${vm.primary.kind}`}
        >
          <Text style={styles.primaryText}>{vm.primary.label}</Text>
        </TouchableOpacity>
      ) : null}
      <TouchableOpacity
        style={styles.secondaryBtn}
        onPress={() => navigateInShell(navigation, 'SupportReports')}
        accessibilityRole="button"
        accessibilityLabel="Abrir soporte"
        testID="home.employee.support"
      >
        <Text style={styles.secondaryText}>Abrir soporte</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  title: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
    marginBottom: spacing.xs,
  },
  primaryBtn: {
    marginTop: spacing.xs,
    alignItems: 'center',
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
  },
  primaryText: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },
  secondaryBtn: {
    marginTop: 4,
    alignItems: 'center',
    paddingVertical: 11,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  secondaryText: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
});
